<script lang="ts">
      import Gafa from "../hero/ui/Gafa.svelte"
      import ImageElement from "./ImageElement.svelte"

      let { image } = $props()
</script>

<div class="w-full py-0">
	<div style="aspect-ratio: {image.width / image.height}/1;" class="w-full mx-auto mt-[6%] mb-[3%] relative">
    <div class="rounded-xl shadow-md overflow-hidden">
      <ImageElement {image}></ImageElement>
    </div>
    <Gafa></Gafa>
		<!--<div class="w-[55%] md:w-[55%] lg:w-[65%] absolute top-0 right-0 aspect-square" style="">
			<img src="/gafa2_rotate.png" alt="gafa tam" class="h-full absolute z-[2] left-[40%] top-[-35%]" />
		</div>-->
	</div>
	
</div>